import { v4 as uuidV4 } from "uuid";

export const transmissionPdfState = {
  pdfId: uuidV4(),
  totalPdfPages: 0,
  totalPreviousReportPdfPages: 0,
  pdfFileName: null,
  allPagesLoadSuccess: false,
  currentPageNumber: 1,
  coverPageLength: 0,
  transmissionReportPdf: null,
  transmissionReportPdfUrl: null,
  previousReportPdfUrl: null,
  isTransmissionReportModified: false,
  isFetchingCoverPage: false,
};
